export default {
  attemptKey(contextModule, { key, withCmd, withShift }) {
    const { getters, commit, rootState, state } = contextModule;

    const { isFreeTextTyping } = state;

    if (rootState.keyboard.enabled) {
      const isCorrect = isFreeTextTyping || getters.expectedKey === key || key.includes('shift');

      commit('setAttemptedKey', {
        character: key,
        withCmd,
        withShift,
        isCorrect,
        expected: getters.expectedKey
      });
    }
  },

  setupNewRound({ commit, dispatch }, options) {
    commit('activity/incrementRound', null, { root: true });
    dispatch('setCurrentStep', { isFirstStep: true, ...options });
  },

  setTypingText({ commit, rootGetters }, options) {
    function getTypingText() {
      if (options?.stepCallback) {
        return options.stepCallback(rootGetters);
      }

      if (rootGetters['activity/currentStep']['answer'])
        return rootGetters['activity/currentStep']['answer'];

      if (
        rootGetters['activity/currentRound']?.typeOverText &&
        rootGetters['activity/currentRound']?.typeOverText.description
      )
        return rootGetters['activity/currentRound'].typeOverText.description;

      return '';
    }

    commit('setNewTypingText', getTypingText());
  },

  setCurrentStep({ commit, dispatch }, options) {
    commit('activity/incrementStep', options, { root: true });
    dispatch('setTypingText', options);
  }
};
